import React from 'react';
import ReactDOM from 'react-dom';
import { ModelManager, Constants } from '@adobe/aem-spa-page-model-manager';
import App from './App';
import './MappedComponents';

import aemReactPolyfill from '../../aem-react-polyfill';

aemReactPolyfill.init(); // Solve ModelManager issues on ie 11

let rootApp = document.querySelector('#customer-number');

window.addEventListener('DOMContentLoaded', () => {
	if (rootApp) {
		function render(model) {
			ReactDOM.render(
				<App
					cqChildren={model[Constants.CHILDREN_PROP]}
					cqItems={model[Constants.ITEMS_PROP]}
					cqItemsOrder={model[Constants.ITEMS_ORDER_PROP]}
					cqPath={ModelManager.rootPath}
					locationPathname={window.location.pathname}
				/>,
				rootApp
			);
		}

		ModelManager.initialize({ path: process.env.REACT_APP_PAGE_MODEL_PATH }).then(render);
	}
});
